// FIXME: build時にhookで切り替えたい

// dev
// export const AppConfig = {
//   ENV: 'development',
//   API_URL_BASE: './api/v1',
//   IS_BROWSER: false,
//   // API_URL_BASE: 'http://pariv.com/api/v1',
//   AUTH_TOKEN_KEY: 'X-Pariv-Token',

//   FIREBASE_PREFIX: 'dev',

// AXES_CLIENTIP: '1019000824',
// AXES_SUCCESS_URL: 'https://staging.paddy67.today/api/v1/axes/register_success',
// AXES_FAILURE_URL: 'https://staging.paddy67.today/api/v1/axes/register_failure',

//   // app status
//   BUNDLE_ID: 'jp.jun.yoshida.paddy.test',
//   APP_VERSION_CODE: '1',
//   APP_VERSION: '5.0.0',

//   ANGULAR_FIRE_CONFIG: {
//     apiKey: 'AIzaSyCMxwqtPtf29X7hIXqjqzG489b7XVquOrk',
//     authDomain: 'pariv-dev-7b510.firebaseapp.com',
//     databaseURL: 'https://pariv-dev-7b510.firebaseio.com/',
//     storageBucket: 'pariv-dev-7b510.appspot.com',
//     messagingSenderId: "204393017822"
//   }
// }

// prod
// export const AppConfig = {
//   ENV: 'production',
//   LOCALE: 'ja-JP',
//   API_URL_BASE: 'https://paddy67.today/api/v1',
//   IS_BROWSER: false,
//   AUTH_TOKEN_KEY: 'X-Pariv-Token',
//   FIREBASE_PREFIX: '',
//   AXES_CLIENTIP: '1014001096',
//   AXES_SUCCESS_URL: 'https://paddy67.today/api/v1/axes/register_success',
//   AXES_FAILURE_URL: 'https://paddy67.today/api/v1/axes/register_failure',
//   BUNDLE_ID: 'jp.jun.yoshida.paddy',
//   APP_VERSION_CODE: '1',
//   APP_VERSION: '2.0.0',
//   ANGULAR_FIRE_CONFIG: {
//   }
// }

// // browser dev
// export const AppConfig = {
//   ENV: "development",
//   API_URL_BASE: "https://staging.paddy67.today/api/v1",
//   API4ASP_URL_BASE: "http://asp.com/api/v1",
//   AUTH_TOKEN_KEY: "X-Pariv-Token",
//   IS_BROWSER: true,

//   FIREBASE_PREFIX: "staging",

//   AXES_CLIENTIP: '1019000824',
//   AXES_SUCCESS_URL: 'https://staging.paddy67.today/api/v1/axes/register_success',
//   AXES_FAILURE_URL: 'https://staging.paddy67.today/api/v1/axes/register_failure',

//   // app status
//   BUNDLE_ID: "jp.jun.yoshida.paddy.test",
//   APP_VERSION_CODE: "1",
//   APP_VERSION: "5.0.0",

//   ANGULAR_FIRE_CONFIG: {
//     apiKey: "AIzaSyCMxwqtPtf29X7hIXqjqzG489b7XVquOrk",
//     authDomain: "pariv-dev-7b510.firebaseapp.com",
//     databaseURL: "https://pariv-dev-7b510.firebaseio.com/",
//     storageBucket: "pariv-dev-7b510.appspot.com",
//     messagingSenderId: "204393017822"
//   }
// };

// browser staging
// export const AppConfig = {
//   ENV: "development",
//   API_URL_BASE: "https://staging.paddy67.today/api/v1",
//   API4ASP_URL_BASE: "http://asp.com/api/v1",
//   AUTH_TOKEN_KEY: "X-Pariv-Token",
//   IS_BROWSER: true,

//   FIREBASE_PREFIX: "staging",

//   AXES_CLIENTIP: '1019000824',
//   AXES_SUCCESS_URL: 'https://staging.paddy67.today/api/v1/axes/register_success',
//   AXES_FAILURE_URL: 'https://staging.paddy67.today/api/v1/axes/register_failure',

//   // app status
//   BUNDLE_ID: "jp.jun.yoshida.paddy.test",
//   APP_VERSION_CODE: "1",
//   APP_VERSION: "5.0.0",

//   ANGULAR_FIRE_CONFIG: {
//     apiKey: "AIzaSyCMxwqtPtf29X7hIXqjqzG489b7XVquOrk",
//     authDomain: "pariv-dev-7b510.firebaseapp.com",
//     databaseURL: "https://pariv-dev-7b510.firebaseio.com/",
//     storageBucket: "pariv-dev-7b510.appspot.com",
//     messagingSenderId: "204393017822"
//   }
// };

// browser prod
export const AppConfig = {
  ENV: "production",
  API_URL_BASE: "https://paddy67.today/api/v1",
  API_URL_BASE_V2: "https://paddy67.today/api/v2",
  API4ASP_URL_BASE: "https://asp.paddy67.today/api/v1",
  AUTH_TOKEN_KEY: "X-Pariv-Token",
  IS_BROWSER: true,

  FIREBASE_PREFIX: "",

  AXES_CLIENTIP: "1014001096",
  AXES_SUCCESS_URL: "https://paddy67.today/api/v1/axes/register_success",
  AXES_FAILURE_URL: "https://paddy67.today/api/v1/axes/register_failure",

  // app status
  BUNDLE_ID: "jp.jun.yoshida.paddy",
  APP_VERSION_CODE: "1",
  APP_VERSION: "5.0.0",

  ANGULAR_FIRE_CONFIG: {
    apiKey: "AIzaSyCxce4x_kh_lZ3vLKWdQ8eoQSW1eA7O7CU",
    authDomain: "paddy-prod.firebaseapp.com",
    databaseURL: "https://pariv-production.firebaseio.com/",
    storageBucket: "paddy-prod.appspot.com",
    messagingSenderId: "919121827692",
  },
};



// WEBPACK FOOTER //
// ./src/app/app.config.ts